import request from "library/v1/request";

export function showProfile() {
  return request({
    url: `profile`,
    method: 'get'
  })
}

export function updatePersonalInfo(data) {
  return request({
    url: `profile/personal_information`,
    method: 'patch',
    data
  })
}

export function updateMedicalHistory(data) {
  return request({
    url: `profile/medical_history`,
    method: 'patch',
    data
  })
}

export function updatePreferences(data) {
  return request({
    url: `profile/preferences`,
    method: `patch`,
    data
  })
}

export function createConsent(data) {
  return request({
    url: 'profile/consent_form_permissions',
    method: `post`,
    data
  })
}

export function updateInsurance(data) {
  return request({
    url: 'profile/insurance_intake',
    method: `put`,
    headers: {
      'Content-type': 'multipart/form-data',
    },
    data
  })
}

export function createAuthorizedContact(data) {
  return request({
    url: 'profile/authorized_contacts',
    method: `post`,
    data
  })
}

export function revokeAuthorizedContact(id) {
  return request({
    url: `profile/authorized_contacts/${id}/revoke`,
    method: `patch`
  })
}

export function reAuthorizeContact(id) {
  return request({
    url: `profile/authorized_contacts/${id}/re_authorize`,
    method: `patch`
  })
}
